import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
const tomos = [{
  num: 1,
  title: 'Entender la Etapa',
  color: 'bg-blue-600',
  border: 'border-blue-500',
  text: 'text-blue-400'
}, {
  num: 2,
  title: 'Comunicación',
  color: 'bg-yellow-500',
  border: 'border-yellow-500',
  text: 'text-yellow-400'
}, {
  num: 3,
  title: 'Organización',
  color: 'bg-orange-500',
  border: 'border-orange-500',
  text: 'text-orange-400'
}, {
  num: 4,
  title: 'Decisiones Difíciles',
  color: 'bg-red-600',
  border: 'border-red-500',
  text: 'text-red-400'
}, {
  num: 5,
  title: 'Cuidado y Límites',
  color: 'bg-purple-600',
  border: 'border-purple-500',
  text: 'text-purple-400'
}, {
  num: 6,
  title: 'Preparación a Futuro',
  color: 'bg-teal-600',
  border: 'border-teal-500',
  text: 'text-teal-400'
}];
export function WhatYouReceive() {
  return <section className="w-full bg-[#000000] py-8 md:py-12 px-4" data-id="element-383">
      <div className="max-w-3xl mx-auto" data-id="element-384">
        <div className="text-center mb-6" data-id="element-385">
          <h2 className="text-2xl md:text-4xl font-black font-heading text-white mb-2" data-id="element-386">
            📦 LO QUE RECIBES
          </h2>
          <p className="inline-block bg-red-600/10 border border-red-600/30 text-red-500 px-5 py-1.5 rounded-full text-sm md:text-base font-bold font-heading tracking-wide" data-id="element-387">
            6 TOMOS COMPLETOS + 6 BONOS
          </p>
        </div>

        {/* Summary block like reference */}
        <div className="bg-gray-900 rounded-2xl p-5 md:p-6 border border-gray-800 mb-6" data-id="element-388">
          <p className="text-center text-base md:text-lg text-gray-200 font-body leading-relaxed" data-id="element-389">
            <span className="font-black text-white" data-id="element-390">
              6 tomos organizados por etapa.
            </span>{' '}
            Ejercicios prácticos, ejemplos reales y estrategias listas para
            usar.{' '}
            <span className="font-black text-white" data-id="element-391">6 bonos estratégicos.</span>{' '}
            Todo listo para aplicar desde hoy.
          </p>

          {/* Colored tomo cards row */}
          <div className="grid grid-cols-6 gap-2 md:gap-3 mt-5 mb-3" data-id="element-392">
            {tomos.map(tomo => <div key={tomo.num} className={`${tomo.color} rounded-lg aspect-[3/4] flex items-center justify-center shadow-lg cursor-pointer hover:scale-105 transition-transform duration-300`} onClick={scrollToPricing} data-id="element-393">
                <span className="text-white font-black text-lg md:text-2xl font-heading drop-shadow-md" data-id="element-394">
                  {tomo.num}°
                </span>
              </div>)}
          </div>

          <p className="text-center text-gray-500 text-xs md:text-sm font-body" data-id="element-395">
            — Sistema completo para acompañar esta etapa
          </p>
        </div>

        {/* Tomo list - compact */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6" data-id="element-396">
          {tomos.map(tomo => <div key={tomo.num} className={`bg-gray-900 rounded-xl p-3 border-l-4 ${tomo.border} flex items-center gap-3`} data-id="element-397">
              <div className={`${tomo.color} w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-398">
                <span className="text-white font-black text-sm font-heading" data-id="element-399">
                  {tomo.num}
                </span>
              </div>
              <div data-id="element-400">
                <h3 className={`text-sm font-black font-heading ${tomo.text}`} data-id="element-401">
                  TOMO {tomo.num}
                </h3>
                <p className="text-xs text-gray-400 font-body leading-tight" data-id="element-402">
                  {tomo.title}
                </p>
              </div>
            </div>)}
        </div>

        {/* What each tomo includes */}
        <div className="bg-gray-900 rounded-2xl p-5 md:p-6 border border-green-500/30 shadow-[0_0_15px_rgba(34,197,94,0.05)] relative overflow-hidden" data-id="element-403">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-600 to-green-400" data-id="element-404"></div>
          <h3 className="text-lg md:text-xl font-black font-heading text-white mb-4 text-center" data-id="element-405">
            📌 Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 max-w-xl mx-auto" data-id="element-406">
            <div className="flex items-center gap-2 bg-gray-800/50 p-2.5 rounded-lg border border-gray-700/50" data-id="element-407">
              <span className="text-green-500 text-base flex-shrink-0" data-id="element-408">✅</span>
              <p className="text-gray-300 font-body text-xs md:text-sm" data-id="element-409">
                Explicación clara y sin tecnicismos
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2.5 rounded-lg border border-gray-700/50" data-id="element-410">
              <span className="text-green-500 text-base flex-shrink-0" data-id="element-411">✅</span>
              <p className="text-gray-300 font-body text-xs md:text-sm" data-id="element-412">
                Ejercicios prácticos aplicables
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2.5 rounded-lg border border-gray-700/50" data-id="element-413">
              <span className="text-green-500 text-base flex-shrink-0" data-id="element-414">✅</span>
              <p className="text-gray-300 font-body text-xs md:text-sm" data-id="element-415">
                Ejemplos reales
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2.5 rounded-lg border border-gray-700/50" data-id="element-416">
              <span className="text-green-500 text-base flex-shrink-0" data-id="element-417">✅</span>
              <p className="text-gray-300 font-body text-xs md:text-sm" data-id="element-418">
                Estrategias listas para usar
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2.5 rounded-lg border border-gray-700/50 md:col-span-2 md:max-w-[50%] md:mx-auto" data-id="element-419">
              <span className="text-green-500 text-base flex-shrink-0" data-id="element-420">✅</span>
              <p className="text-gray-300 font-body text-xs md:text-sm" data-id="element-421">
                Lenguaje simple y directo
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-6" data-id="element-422">
          <button onClick={scrollToPricing} className="w-full md:w-auto hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 py-4 rounded-xl shadow-[0_0_25px_rgba(250,204,21,0.3)] animate-pulse-glow transition-all duration-300 cursor-pointer font-heading bg-[#58C86F]" data-id="element-423">
            👉 ADQUIRIR EL PACK AHORA
          </button>
        </div>
      </div>
    </section>;
}